<template>
    
	<div class="limiter">
		<div class="container-login100">
			<div class="wrap-login100 p-l-55 p-r-55 p-t-65 p-b-50">
				<form class="login100-form validate-form">
					<span class="login100-form-title p-b-33">
						Prihlasenie 
					</span>

					<div class="wrap-input100 validate-input" data-validate = "Valid email is required: ex@abc.xyz">
						<input class="input100" type="text" name="email" placeholder="Email" @input="updateEmail">
						<span class="focus-input100-1"></span>
						<span class="focus-input100-2"></span>
					</div>

					<div class="wrap-input100 rs1 validate-input" data-validate="Password is required">
						<input class="input100" type="password" name="pass" placeholder="Password" @input="updatePassword">
						<span class="focus-input100-1"></span>
						<span class="focus-input100-2"></span>
					</div>

					<div class="container-login100-form-btn m-t-20">
						<button type="button" href="#" class="txt2 hov1" @click="login">
							Prihlasit sa
						</button>
					</div>
<hr>

				</form>
			</div>
		</div>
	</div>
</template>
<script>
import firebase from 'firebase'
//import axios from 'axios'

export default {
  name: 'login',
  props: {
    msg: String
  },
  data()
  {
    return {
      projects : []  
    }
  },
  created() {
    console.log("login created");
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
  console.log("-- user --");
  console.log(localStorage.getItem('email'));
  console.log(localStorage.getItem('password'));
  console.log(this.$store.getters.user.loggedIn);

    if(this.$store.getters.user.loggedIn)
    {
          console.log("redirect");
          console.log("LOG1: " + this.$store.getters.user.loggedIn);
          this.$router.push('/tracker');
    }
    else
    {
          console.log("redirect not");
          console.log("LOG2: " + this.$store.getters.user.loggedIn);
    }

  },
  methods : {
    async getData()
    {


    await firebase.firestore().collection('project').get().then(snap => {
      console.log(snap.docs.map(x => x.data()));
      this.projects = snap.docs.map(x => x.data());
      
    });
    
const pr = firebase.firestore().collection('project');

await pr.doc('123').set({
  name: 'SuperProjet'
});



    },
    updateEmail(e)
    {
      this.$store.commit('setEmail', e.target.value);
    },
    updatePassword(e)
    {
      this.$store.commit('setPassword', e.target.value);
    },
    async getUserData(e)
    {
      console.log("finding " + e);
        await firebase.firestore().collection('user').where('email', '==', e).get().then(snap => {
          console.log("docs");
          console.log(snap.docs[0].data());
          this.$store.commit('setRole', snap.docs[0].data().role);
        });
    },
    login()
    {
        console.log("? " + this.$store.getters.user.email);
      var email = this.$store.getters.email;
      var password = this.$store.getters.password;
      var toast = this.$toast;
      console.log("logging in with " + email + " and " + password);
      firebase.auth().signInWithEmailAndPassword(this.$store.getters.user.email, this.$store.getters.password).then( res => {
        console.log(res);
        this.$store.commit('userLoggedIn');
        this.$router.push('/tracker');
        this.getUserData(this.$store.getters.user.email);        

      } ).catch(function(error) {
          toast.error('Nesprávne prihlasovacie údaje.', { position:'top' });
        console.log(error);
      });

    }
  }
}
</script>
